/**
 * @file 排序组件
 * @author surer 2024-04-07
 */

import { FC, useEffect, useMemo, useState } from 'react';
import Image from 'next/image';
import CommonDropdown, { IMenuListItem } from '../CommonDropdown/mIndex';
import cn from 'classnames';

import Styles from './mIndex.module.scss'

const sortDorpDown = require('@/assets/icon/sort-dorp-down.png');
const sortDorpDownActive = require('@/assets/icon/sort-dorp-down-active.png');

export enum SortFilteTypeEnum {
  dropdown = 'dropdown',
  segment = 'segment',
}

export interface SortFilteProps {
  className?: string;
  /** 排序组件UI类型 */
  type?: SortFilteTypeEnum;
  /** 所有排序方式 */
  sortList: IMenuListItem[];
  /** 当前选中的排序方式 */
  activeSort?: string;
  getPopupContainer?: () => HTMLElement;
  onChange: (key: string) => void;
}

export const SortFilter: FC<SortFilteProps> = (props) => {
  const {
    className,
    type = SortFilteTypeEnum.segment,
    sortList,
    activeSort,
    getPopupContainer,
    onChange,
  } = props;

  const [activeKey, setActiveKey] = useState<string>(activeSort || sortList?.[0].key);

  const onSortChange = (key: string) => {
    if (key === activeKey) {
      return;
    }
    setActiveKey(key);
    onChange(key);
  }

  useEffect(() => {
    if (activeSort) {
      setActiveKey(activeSort);
    } else {
      setActiveKey(sortList?.[0].key);
    }
  }, [activeSort])


  const isDefaultKey = useMemo(()=>{
    return activeKey === sortList?.[0].key;
  },[activeKey,sortList]);

  return (
    <div className={cn(Styles.root, className)}>
      {
        type === SortFilteTypeEnum.segment && (
          <div className={cn(Styles.segmentControl)}>
            {sortList?.map((item) => {
              return (
                <div
                  key={item.key}
                  className={cn(Styles.segment, {[Styles.active]: activeKey === item.key})}
                  onClick={() => onSortChange(item.key)}
                >
                  {item.text}
                </div>
              );
            })}
          </div>
        )
      }
      {
        type === SortFilteTypeEnum.dropdown && (
          <div className={cn(Styles.dropdownMenu)}>
            <CommonDropdown
              menuList={sortList}
              leftTriggerNode={
                <div className={Styles.triggerLeftIcon}>
                  <Image
                    src={isDefaultKey ? sortDorpDown : sortDorpDownActive}
                    alt="empty-device"
                    className={Styles.sortDorpDown}
                    loader={({ src }) => src}
                  />
                </div>
              }
              // rightTriggerNode={
              //   <span className={Styles.triggerRightText}>{sortList?.find((item) => item.key === activeKey)?.text}</span>
              // }
              getPopupContainer={getPopupContainer}
              activeKey={activeKey}
              onSelectMenu={onSortChange}
            />
          </div>
        )
      }
    </div>
  );
}
